import React, { useCallback } from 'react';
import * as cnst from '@ts/consts';
const btnShopFilter = ({ id, label, onClick }) => {
    const handleClick = useCallback(onClick, [
        label
    ]);
    return (React.createElement("span", { onClick: handleClick },
        React.createElement("img", { src: `./assets/img/misc/btn/region_${id}.png?${cnst.CACHEBUSTER}` })));
};
export default btnShopFilter;
